<div [ngClass]="isInWizard ? 'labelWizard' : 'label'">
    <div [ngClass]="[labelBox.class, labelBox.hasAlarm ? 'labelAlarmBorder' : '']" *ngFor="let labelBox of label.data">
        <div [class]="labelBox.valueClass" [style.font-size.px]="valueFontSize" [style.color]="valueColor">
            {{labelBox.value}}</div>
        <div [class]="labelBox.propertyClass" [style.font-size.px]="titleFontSize" [style.color]="titleColor">
            <i *ngIf="labelBox.hasAlarm" class="fas fa-exclamation-triangle labelAlarm" [tooltip]="HtmlContent"
                [options]="tooltipOptions" (mouseenter)="showAlarm(labelBox)"></i>
            <span class="labelProperty">{{labelBox.property}}</span>
        </div>
    </div>
    <ng-template #HtmlContent>
        <div class="popoverContentContainer" *ngIf="alarmProps.length === 1">
            <div *ngFor="let alarm of alarmProps">
                <div class="popoverTitle"><span class="titleText"><i class="fal fa-bell"></i> Alarm for:
                        {{alarmTitle}}</span></div>
                <div class="popoverContent">
                    <span class="contentText">
                        {{ 'dashboard:Alarm Name' | i18next }}: {{alarm['alarmName']}}
                    </span>
                </div>
                <div class="popoverContent">
                    <span class="contentText">
                        {{ 'dashboard:Basic Queue' | i18next }}: {{alarm['basicQueue']}}
                    </span>
                </div>
                <div class="popoverContent">
                    <span class="contentText">
                        {{ 'dashboard:Threshold Type' | i18next }}: {{alarm['thresholdTypeName']}}
                    </span>
                </div>
                <div class="popoverContent">
                    <span class="contentText">
                        {{ 'dashboard:Alarm Time' | i18next }}: {{alarm['alarmTime']}}
                    </span>
                </div>
            </div>
        </div>
        <div *ngIf="alarmProps.length > 1">
            <div class="popoverTitleInline"><span class="titleText">
                    <i class="fal fa-bell"></i> Alarm for: {{alarmTitle}}</span>
            </div>
            <div class="popoverContentContainerInline">
                <table class="alarmTable">
                    <tr>
                        <th class="alarmTh">{{ 'dashboard:Alarm Name' | i18next }}</th>
                        <th class="alarmTh">{{ 'dashboard:Basic Queue' | i18next }}</th>
                        <th class="alarmTh">{{ 'dashboard:Threshold Type' | i18next }}</th>
                        <th class="alarmTh">{{ 'dashboard:Alarm Time' | i18next }}</th>
                    </tr>
                    <tr *ngFor="let alarm of alarmProps">
                        <td class="alarmTd">
                            {{alarm['alarmName']}}
                        </td>
                        <td class="alarmTd">
                            {{alarm['basicQueue']}}
                        </td>
                        <td class="alarmTd">
                            {{alarm['thresholdTypeName']}}
                        </td>
                        <td class="alarmTd">
                            {{alarm['alarmTime']}}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </ng-template>
</div>